import React from "react";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const DialogContainer = props => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      onEnter={props.onEnter}
      onExit={props.onExit}
      aria-labelledby="container-dialog-title"
      aria-describedby="container-dialog-description"
      fullWidth={props.fullWidth}
      maxWidth={props.maxWidth || "md"}
      onEntered={props.onEntered}
    >
      <DialogTitle
        style={{ color: "#43a047" }}
        color="inherit"
        disableTypography={props.disableTypography}
      >
        {props.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText variant="subtitle1">
          {props.contentText}
        </DialogContentText>
        {props.children}
      </DialogContent>
      {props.actions}
    </Dialog>
  );
};

export default DialogContainer;
